export const hostPresenceContentText = {
  titleTabPresence: 'Presensi',
  titleTabContent: 'Konten',
};

export const hostPresenceContentDrawerText = {
  sectionTitle: 'Keterangan Konten',
  paragraphs: [
    'Target konten akan ditentukan setiap bulan. Jumlah target konten disesuaikan dengan jumlah hari pada bulan berjalan.',
    'contoh : <br/> Apabila bulan Februari memiliki 28 hari, maka target konten pada periode tersebut adalah 28 konten.',
    'Submit konten hanya dapat dilakukan 1 kali sehari dengan maksimal 3 link dalam satu kali submit.',
  ],
};

export const hostPresenceOverviewText = {
  clockInText: 'Clock In',
  clockOutText: 'Clock Out',
  livestream1Text: 'Livestream 1',
  livestream2Text: 'Livestream 2',
  livestream3Text: 'Livestream 3',
};

export const hostPresenceContentEmptyStateText = {
  title: 'Belum Ada Data!',
  description: 'Silakan cek kembali nanti — data akan ditampilkan jika sudah tersedia.',
};
